import { ActionTree, GetterTree, MutationTree } from 'vuex';
import { RootState } from '../types';
import { SnackbarState, MutationTypes, GetterTypes, ActionTypes } from './types';

const namespaced: boolean = true;

const state: SnackbarState = {
  show: false,
  message: '',
  color: ''
};

const getters: GetterTree<SnackbarState, RootState> = {
  [GetterTypes.GET_MESSAGE](state): string {
    return state.message;
  },
  [GetterTypes.GET_SHOW](state): boolean {
    return state.show;
  },
  [GetterTypes.GET_COLOR](state): string {
    return state.color;
  }
};

const actions: ActionTree<SnackbarState, RootState> = {
  [ActionTypes.SHOW]({ commit }, payload: SnackbarState): void {
    payload.show = true;
    
    commit(MutationTypes.SET_SHOW, payload);
  }
};

const mutations: MutationTree<SnackbarState> = {
  [MutationTypes.SET_SHOW](state, payload: SnackbarState): void {
    state.show = payload.show;
    state.message = payload.message;
    state.color = payload.color;
  }
};

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
